import { useEffect, Suspense } from "react";
import { Outlet, useLocation, ScrollRestoration } from "react-router-dom";
import DelayedFallback from "./DelayedFallback";
import PageViewTracker from "../../PageViewTracker";
import routes from "../../../routes/productRoutes";
import "../../../styles/Product/loading.scss";

export default function ProductLayout() {
  const location = useLocation();

  useEffect(() => {
    // For different background colors

    // Find the current route in the routes array
    const currentRoute = routes.find(
      (route) => route.path === location.pathname,
    );

    if (currentRoute && currentRoute.className) {
      // Apply the background color class to the body tag
      document.body.className = currentRoute.className;
    } else {
      // If no class is specified, remove any existing classes from the body tag
      document.body.className = "";
    }
  }, [location]);

  return (
    <main className="product">
      <ScrollRestoration />
      <PageViewTracker />
      <Suspense
        fallback={
          <DelayedFallback delay={0}>
            <div className="loading_indicator">
              <img src="/images/logo/logo_black.svg" alt="Claimable" />
              Loading...
            </div>
          </DelayedFallback>
        }
      >
        <Outlet />
      </Suspense>
    </main>
  );
}
